/**
 * Parse a fetch Response body for centralized API clients.
 * Reads JSON via text + JSON.parse so empty bodies with Content-Type: application/json
 * (common on 404) do not throw from response.json().
 */
export async function parseHttpJsonResponseBody(response) {
  if (!response || !response.headers) {
    throw new Error('Invalid response: response or headers is undefined');
  }
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    const raw = await response.text();
    const trimmed = (raw || '').trim();
    if (!trimmed) {
      return {
        success: false,
        error:
          response.status === 404
            ? 'Not found'
            : `Empty response (HTTP ${response.status})`,
      };
    }
    try {
      return JSON.parse(trimmed);
    } catch {
      return {
        success: false,
        error: 'Invalid JSON response',
      };
    }
  }
  const textBody = await response.text();
  return {
    success: false,
    error: (textBody || '').trim() || 'Invalid response format',
  };
}
